import { render, staticRenderFns } from "./AnswerIcon.vue?vue&type=template&id=8a553520&scoped=true&"
import script from "./AnswerIcon.vue?vue&type=script&lang=js&"
export * from "./AnswerIcon.vue?vue&type=script&lang=js&"
import style0 from "./AnswerIcon.vue?vue&type=style&index=0&id=8a553520&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a553520",
  null
  
)

export default component.exports